import {
  Box,
  Button,
  Chip,
  Popover,
  Typography,
  useTheme,
} from '@mui/material'
import {
  IconArrowBearRight,
  IconBookmark,
  IconBookmarkFilled,
  IconCalendarCheck,
  IconChevronDown,
  IconClockHour7,
  IconCurrencyDollar,
  IconMapPin,
  IconMessageDots,
  IconPhone,
  IconPointFilled,
  IconRosetteDiscountCheck,
} from '@tabler/icons-react'
import styled from 'styled-components'

export const RestaurantInfoMainContainer = styled(Box).attrs(() => ({
  width: '100%',
  display: 'flex',
  marginTop: '40px',
  marginBottom: '32px',
  justifyContent: 'space-between',
  flexDirection: { xs: 'column', md: 'row' },
}))(() => ({}))

export const RestaurantInfoInnerContainer = styled(Box).attrs(() => ({
  flex: '2',
  marginRight: { sm: '0', md: '16px' },
}))(() => ({}))

export const RestaurantInfoTitleWrapper = styled(Box).attrs(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: { xs: '8px', md: '12px' },
  flexWrap: 'wrap',
}))(() => ({}))

export const RestaurantInfoTitleTypography = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h3',
    fontWeight: 500,
    color: theme.palette.text.primary,
    sx: {
      textTransform: 'capitalize',
      wordBreak: 'break-word',
      flex: '0 1 auto',
      maxWidth: { xs: 'calc(100% - 60px)', md: '400px' },
    },
  }
})(() => ({}))

export const RestaurantInfoTitleChip = styled(Chip).attrs(() => {
  const theme = useTheme()
  return {
    size: 'small',
    variant: 'outlined',
    sx: {
      fontWeight: 400,
      color: theme.palette.success.dark,
      borderColor: theme.palette.success.dark,
      backgroundColor: theme.palette.success[50],
      ml: '10px',
    },
  }
})(() => ({}))

export const RestaurantInfoTitleChipWrapper = styled(Box).attrs(() => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
}))(() => ({}))

export const RestaurantInfoTitleChipIconRosetteDiscountCheck = styled(
  IconRosetteDiscountCheck,
).attrs(() => {
  const theme = useTheme()
  return {
    stroke: 2,
    size: 17,
    color: theme.palette.success.dark,
  }
})(() => ({ fontSize: '14px' }))

export const RestaurantInfoTitleVerifiedTypography = styled(Typography).attrs(
  () => ({
    variant: 'caption',
    sx: { ml: '3px' },
  }),
)(() => ({}))

export const RestaurantInfoSignUpTypography = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'subtitle1',
    fontWeight: 500,
    color: theme.palette.primary.main,
    sx: {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
      marginRight: '4px',
      marginLeft: '0px',
      cursor: 'pointer',
      fontSize: '12px',
      lineHeight: '16px',
    },
  }
})(() => ({}))

export const RestaurantInfoAiMatchTypography = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'subtitle1',
    component: 'span',
    fontWeight: 400,
    color: theme.palette.grey[400],
    sx: {
      fontSize: '12px',
      lineHeight: '16px',
    },
  }
})(() => ({}))

export const RestaurantBasicInfoWrapper = styled(Box).attrs(() => ({
  sx: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
    gap: { xs: '16px', md: '20px' },
    marginTop: '24px',
    marginBottom: '24px',
    width: '100%',
  },
}))(() => ({}))

export const RestaurantBasicInfoAddressWrapper = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      backgroundColor: theme.palette.grey[50],
      padding: '16px',
      borderRadius: '12px',
      border: `1px solid ${theme.palette.grey[200]}`,
    },
  }
})(() => ({}))

export const RestaurantBasicInfoLocationItem = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:last-child': {
      marginLeft: '26px',
    },
  },
}))(() => ({}))

export const RestaurantBasicInfoIconMapPin = styled(IconMapPin).attrs(() => {
  const theme = useTheme()
  return {
    size: 18,
    stroke: 2,
    color: theme.palette.grey[600],
  }
})(() => ({}))

export const RestaurantBasicInfoAddressTypography = styled(Typography).attrs(
  () => {
    const theme = useTheme()
    return {
      variant: 'body2',
      component: 'div',
      fontWeight: 500,
      color: theme.palette.grey[700],
      sx: {
        fontSize: '15px',
        lineHeight: 1.5,
      },
    }
  },
)(() => ({}))

export const RestaurantBasicInfoIconPointFilled = styled(IconPointFilled).attrs(
  () => {
    const theme = useTheme()
    return {
      color: theme.palette.grey[300],
      size: 12,
    }
  },
)(() => ({}))

export const RestaurantBasicInfoDistanceTypography = styled(Typography).attrs(
  () => {
    const theme = useTheme()
    return {
      variant: 'body2',
      component: 'span',
      fontWeight: 500,
      color: theme.palette.grey[600],
      sx: { textTransform: 'lowercase' },
    }
  },
)(() => ({}))

export const RestaurantBasicInfoTimeWrapper = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      backgroundColor: theme.palette.grey[50],
      padding: '16px',
      borderRadius: '12px',
      border: `1px solid ${theme.palette.grey[200]}`,
    },
  }
})(() => ({}))

export const RestaurantBasicInfoTimezoneWrapper = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
  },
}))(() => ({}))

export const RestaurantBasicInfoTimeInfoItem = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
}))(() => ({}))

export const RestaurantBasicInfoTimeIconClockHour7 = styled(
  IconClockHour7,
).attrs(() => {
  return {
    size: 18,
    stroke: 2,
  }
})(() => ({}))

export const RestaurantBasicInfoActiveTimeTypography = styled(Typography).attrs(
  () => ({
    variant: 'body2',
    component: 'span',
    fontWeight: 500,
    sx: {
      textTransform: 'lowercase',
      paddingLeft: '6px',
    },
  }),
)(() => ({}))

export const RestaurantBasicInfoTimeButton = styled(Button).attrs(() => {
  return {
    variant: 'text',
    sx: {
      textTransform: 'capitalize',
      marginLeft: '6px',
    },
  }
})(() => ({}))

export const RestaurantBasicInfoTimeButtonIconChevronDown = styled(
  IconChevronDown,
).attrs(() => {
  const theme = useTheme()
  return {
    color: theme.palette.grey[400],
    stroke: 2,
    size: 18,
  }
})(() => ({}))

export const RestaurantBasicInfoTimeTodayTypography = styled(Typography).attrs(
  () => {
    const theme = useTheme()
    return {
      variant: 'subtitle1',
      component: 'span',
      fontWeight: 500,
      color: theme.palette.grey[400],
      sx: {
        textTransform: 'capitalize',
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
      },
    }
  },
)(() => ({}))

export const RestaurantBasicInfoPriceRangeWrapper = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
  },
}))(() => ({}))

export const RestaurantBasicInfoPriceRangeIconCurrencyDollar = styled(
  IconCurrencyDollar,
).attrs(() => {
  const theme = useTheme()
  return {
    size: 18,
    color: theme.palette.grey[600],
    stroke: 2,
  }
})(() => ({}))

export const RestaurantBasicInfoPriceRangeTypography = styled(Typography).attrs(
  () => {
    const theme = useTheme()
    return {
      variant: 'body2',
      component: 'span',
      fontWeight: 500,
      color: theme.palette.grey[600],
      sx: { textTransform: 'capitalize' },
    }
  },
)(() => ({}))

export const RestaurantBasicInfoPriceRangePerPersonTypography = styled(
  Typography,
).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'subtitle1',
    component: 'span',
    fontWeight: 500,
    color: theme.palette.grey[400],
  }
})(() => ({}))

export const RestaurantBasicInfoPopover = styled(Popover).attrs(() => {
  return {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    sx: {
      '& .MuiPaper-root': {
        borderRadius: '8px',
        width: '230px',
      },
    },
  }
})(() => ({}))

export const RestaurantBasicInfoPopoverWrapper = styled(Box).attrs(() => {
  return {
    padding: '8px',
  }
})(() => ({}))

export const RestaurantBasicInfoPopoverInnerWrapper = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      padding: '8px',
    },
  }
})(() => ({}))

export const RestaurantBasicInfoPopoverDayTypography = styled(Typography).attrs(
  () => {
    return {
      noWrap: true,
      component: 'p',
      variant: 'subtitle2',
    }
  },
)(() => ({}))

export const RestaurantBasicInfoPopoverTimeWrapper = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '5px',
    },
  }
})(() => ({}))

export const RestaurantBasicInfoPopoverTimeTypography = styled(
  Typography,
).attrs(() => {
  return {
    noWrap: true,
    component: 'p',
    variant: 'subtitle2',
  }
})(() => ({}))

export const RestaurantBasicInfoChipWrapper = styled(Box).attrs(() => {
  return {
    sx: {
      gap: '8px',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: '24px',
      marginBottom: '16px',
    },
  }
})(() => ({}))

export const RestaurantBasicInfoChipChip = styled(Chip).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      height: '32px',
      fontSize: '14px',
      fontWeight: 500,
      borderRadius: '20px',
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
      border: `1.5px solid ${theme.palette.primary.main}`,
      padding: '4px 12px',
    },
  }
})(() => ({}))

export const RestaurantInfoActionContainer = styled(Box).attrs(() => {
  return {
    sx: {
      display: 'grid',
      gridTemplateColumns: { xs: '1fr 1fr', md: 'auto auto auto auto auto' },
      gap: { xs: '12px', md: '8px' },
      marginTop: { xs: '24px', md: '0' },
      marginBottom: { xs: '24px', md: '0' },
      alignItems: 'center',
      justifyContent: { xs: 'start', md: 'start' },
      width: { xs: '100%', md: 'auto' },
    },
  }
})(() => ({}))

export const RestaurantInfoActionReserveTableButton = styled(Button).attrs(
  () => {
    const theme = useTheme()
    return {
      component: 'a',
      variant: 'contained',
      color: 'primary',
      target: '_blank',
      disableElevation: true,
      rel: 'noopener noreferrer',
      sx: {
        fontSize: { xs: '14px', md: '15px' },
        borderRadius: '10px',
        fontWeight: 600,
        textTransform: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: '12px',
        paddingX: '18px',
        gridColumn: { xs: 'span 2', md: 'auto' },
        '&.MuiButton-root': {
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: 'white',
          },
        },
      },
    }
  },
)(() => ({}))

export const RestaurantInfoActionIconCalendarCheck = styled(
  IconCalendarCheck,
).attrs(() => {
  return {
    size: 14,
    stroke: 2,
  }
})(() => ({}))

export const RestaurantInfoActionDirectionsWebButton = styled(Button).attrs(
  () => {
    const theme = useTheme()
    return {
      component: 'a',
      variant: 'outlined',
      target: '_blank',
      disableElevation: true,
      rel: 'noopener noreferrer',
      sx: {
        fontSize: { xs: '14px', md: '15px' },
        borderRadius: '10px',
        fontWeight: 600,
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: '12px',
        paddingX: '18px',
        borderColor: theme.palette.grey[300],
        color: theme.palette.grey[800],
        gridColumn: { xs: 'auto', md: 'auto' },
        '&.MuiButton-root': {
          borderColor: theme.palette.grey[300],
          '&:hover': {
            backgroundColor: theme.palette.grey[50],
            borderColor: theme.palette.grey[400],
          },
        },
      },
    }
  },
)(() => ({}))

export const RestaurantInfoActionDirectionsWebButtonIconArrowBearRight = styled(
  IconArrowBearRight,
).attrs(() => {
  return {
    size: 18,
    stroke: 2,
  }
})(() => ({}))

export const RestaurantInfoActionIconArrowBearRight = styled(
  IconArrowBearRight,
).attrs(() => {
  const theme = useTheme()
  return {
    size: 18,
    color: theme.palette.grey[800],
    stroke: 2,
  }
})(() => ({}))

export const RestaurantInfoActionIconPhone = styled(IconPhone).attrs(() => {
  const theme = useTheme()
  return {
    size: 18,
    color: theme.palette.grey[800],
    stroke: 2,
  }
})(() => ({}))

export const RestaurantInfoActionIconMessage = styled(IconMessageDots).attrs(
  () => {
    const theme = useTheme()
    return {
      size: 18,
      color: theme.palette.grey[800],
      stroke: 2,
    }
  },
)(() => ({}))

export const RestaurantInfoActionIconBookmarkFilled = styled(
  IconBookmarkFilled,
).attrs(() => {
  const theme = useTheme()
  return {
    size: 18,
    color: theme.palette.grey[800],
  }
})(() => ({}))

export const RestaurantInfoActionIconBookmark = styled(IconBookmark).attrs(
  () => {
    const theme = useTheme()
    return {
      size: 18,
      color: theme.palette.grey[800],
      stroke: 2,
    }
  },
)(() => ({}))

export const RestaurantMatchDescriptionCard = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      backgroundColor: theme.palette.grey[50],
      borderRadius: '12px',
      border: `1px solid ${theme.palette.grey[200]}`,
      padding: '16px',
      marginTop: '24px',
      marginBottom: '24px',
    },
  }
})(() => ({}))

export const RestaurantMatchDescriptionTitle = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'overline',
    component: 'div',
    sx: {
      color: theme.palette.text.secondary,
      marginBottom: '8px',
    },
  }
})(() => ({}))

export const RestaurantMatchDescriptionText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    component: 'div',
    sx: {
      fontSize: '15px',
      fontWeight: 400,
      color: theme.palette.grey[700],
      fontStyle: 'italic',
      lineHeight: 1.6,
    },
  }
})(() => ({}))

export const CoinImage = styled(Box).attrs(() => ({
  component: 'img',
  src: '/images/leaderboard/coin-yellow.png',
  sx: {
    width: '14px',
    aspectRatio: '1',
  },
}))(() => ({}))

export const CoinContainer = styled(Box).attrs(() => ({
  display: 'flex',
  alignItems: 'center',
  px: '4px',
  py: '3px',
  ml: 1.5,
  mt: '3px',
  sx: {
    gap: '4px',
    backgroundColor: 'primary.main',
    borderRadius: '15px',
  },
}))(({ theme }) => ({}))
